import React from 'react';
import classNames from 'classnames';

type EditorImageSkeletonProps = {
  width: string;
  height: string;
  className?: string;
};

export function EditorImageSkeleton({
  width,
  height,
  className,
}: EditorImageSkeletonProps) {
  return (
    <span
      className={classNames('email-builder-editor-image-skeleton', className)}
      style={{ width, height }}
      aria-hidden
    />
  );
}
